import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';

export const Headline = styled.div`
  color: ${Colors.grey900};
  font-weight: 800;
  font-size: 16px;
  line-height: 150%;
  width: 100%;
  ${mediaQueries.tablet} {
    font-size: 23px;
    line-height: 125%;
  }
`;
